import { ReactElement } from 'react';
import { S_ListSelect } from '../../../../../../../../design/inputs/select/S_ListSelect';
import { FilterContent } from '../FilterContent';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

export const AnnotatedByBody = ({ availableFilters, imageFilters, onSetAnnotatedBy }: ImageFiltersFormProps): ReactElement => {
  const options = availableFilters.annotatedBy.map((x) => ({ value: x.id, label: x.email, searchableLabel: x.email }));

  return (
    <FilterContent>
      <S_ListSelect
        options={options}
        selected={imageFilters.annotatedBy}
        onChange={onSetAnnotatedBy}
      />
    </FilterContent>
  );
};
